import {
    scroll  
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function Footer({
    length, 
    pageNumbers, 
    
    currentPage, 
    setCurrentPage, 
    itemsPerPage, 
    setItemsPerPage, 

    parentId,
    paginateAction, 
    pageSelectId
}){
    //------------------------------------------------------
    const paginate = pageNumber => {
        if (typeof paginateAction === 'function') {
            paginateAction();
        }
        setCurrentPage(pageNumber);
        if(parentId) scroll(parentId); else scroll(null);
    };
    //--------------------------------------------------------------------------------------------
    return(
        <footer className = "position-absolute w-100">
            <nav className = "d-flex justify-content-end px-4 pt-3">
                <div className = "overflow-auto">
                <ul className = "pl-0 mb-0 d-flex cssPage" >
                    {pageNumbers.map(pageNumber => (
                    <li key = {pageNumber}>
                        <button
                            type = "button"
                            onClick = {() => paginate(pageNumber)}
                            style = {{
                                background:
                                currentPage === pageNumber?
                                "#e9ecef":null
                            }}
                            className = "page-link ml-0 paginationOutline"
                        >
                            {pageNumber}
                        </button>
                    </li> 
                    ))}
                </ul>
                </div>
            </nav>
            <div className = "text-nowrap mt-3 pr-4 d-flex justify-content-end align-items-center">
                <span>Total: {length}</span>
                <select id = {"pageSelect " + (pageSelectId ?? "main")} className = "form-control d-inline pageNumberSelectWidth ml-3" value = {itemsPerPage} onChange = {e => {
                    setCurrentPage(1);
                    setItemsPerPage(e.currentTarget.value);
                    scroll(null);
                }}>
                    <option>1</option>
                    <option>5</option>
                    <option>10</option>
                    <option>20</option>
                    <option>50</option>
                    <option>100</option>
                </select>
            </div>
        </footer>
    )
}